import { WATCH_YOUTUBE_VIDEOS } from "../actionTypes";

export const watchyoutubevideosfunc = (data) => 
{
    return {
        type: WATCH_YOUTUBE_VIDEOS,
        data: data,
    }
}